import { OpenFlag } from 'api/resort/types';
import { useOpenFlagTranslation } from 'i18n/useOTSTranslation';

import styles from './styles.module.scss';

const styleMap: Record<OpenFlag, string> = {
  [OpenFlag.Closed]: styles.closed,
  [OpenFlag.NoReportAvailable]: styles.partial,
  [OpenFlag.PermanentlyClosed]: styles.closed,
  [OpenFlag.Open]: styles.open,
  [OpenFlag.WeekendsOnly]: styles.open,
  [OpenFlag.TemporarilyClosed]: styles.partial,
};

export const OpenStatus = ({ flag }:{ flag?: OpenFlag }) => {
  const eT = useOpenFlagTranslation();
  return <span className={styleMap[flag || OpenFlag.Closed]}>{flag ? eT(flag) : ''}</span>;
};
